import './submissions_table.css';
import React, { useEffect,useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import Widget_count_elements from '../widget_count_elements/widget_count_elements'
import {makeStyles} from '@mui/styles';


function submission_treated(stat){
    return(
      <>
        {
         stat == 0
         ?<Button variant="contained" className="status_deny">refusée</Button>
         :stat == 1
         ?<Button variant="contained" className="status_success">acceptée</Button>
         :<Button variant="contained" className="status_waiting">en cours</Button>
        }
      </>
  
    );
  }

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const columns = [
    { id: 'Objet', label: "Objet d'appel", minWidth: 0 },
    { id: 'direction', label: "Direction", minWidth: 0 },
    { id: 'categorie', label: "Famille d'achat", minWidth: 0 },
    { id: 'supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'accord', label: "Accord", minWidth: 0 }
  ];
  

function Submissions({submissions,getCategorieById}){
    
    return(
        <>
        {
            submissions.map((submission,index1) => (
                <TableRow key={submission.offer_id+"col"+index1}>
                    <TableCell align="left">{submission.object}</TableCell>
                    <TableCell align="left">{submission.direction}</TableCell>
                    <TableCell align="left">{getCategorieById(submission.purchase_family)}</TableCell>
                    <TableCell align="left">{submission.fullName}</TableCell>
                    <TableCell align="center">
                        {submission_treated(submission.accord)}
                    </TableCell>
                </TableRow>                
             ))
        }
        </>
    );
}


function Submissions_table({categories,data}) {

    const classes = useStyles();
    const [show_elemnts,setShowing_elements] = useState(false);


    function getCategorieById(id){
        var categorie="";
        categories.map((catg)=>{
          if(catg.id_category == id) categorie = catg.name;
        })
        return categorie;
    }



//////////////////////
/////////////////////////////////////////////////////////
///////////////////////////////////

  return (
    <>
    {
      show_elemnts!==true
        ?<Widget_count_elements setShowing_elements={setShowing_elements} elements_number={data.count} fontColor="#51a5cf" progress={data.progress} />
        :<TableContainer className="submissions_table" component={Paper}  onContextMenu={(e) => {e.preventDefault();setShowing_elements(false)}} style={{cursor:'pointer'}} onTouchStartCapture={(e)=>{e.stopPropagation();setShowing_elements(false)}} >
            <Table className={classes.table} aria-label="sticky table">
                <TableHead>
                <TableRow>
                    {
                        columns.map((column) => (
                            <TableCell key={column.id} align="left">{column.label}</TableCell>
                        ))
                    }
                </TableRow>
                </TableHead>
                <TableBody>
                {
                    data.last_submissions.length!=0
                    ?
                    <>
                        <Submissions submissions={data.last_submissions} getCategorieById={getCategorieById} />
                    </>
                            
                    :<div style={{margin:"10px",fontSize:".8rem",width:'100%', textAlign:"center",alignContent:"center"}}>Aucun offre disponible</div>
                }
                </TableBody> 
            </Table>
        </TableContainer>
    }
    
      
    </>
    
  );
}

export default React.memo(Submissions_table);
